import React from 'react';
import { useLocation } from 'react-router-dom';

import { TagParams } from 'tags/types/tagged';

import { useCurrentPlan } from 'organizations/hooks/useCurrentPlan';

export function useTagsFilterParams(): TagParams {
  const { search } = useLocation();

  const { data: currentPlan, isSuccess } = useCurrentPlan();

  const canCreateTags =
    (isSuccess && currentPlan === null) ||
    Boolean(currentPlan?.can_create_tags);

  return React.useMemo(() => {
    if (!canCreateTags) {
      return {};
    }

    const urlSearchParams = new URLSearchParams(search);
    let onlyUntagged: boolean | undefined = undefined;
    let taggedWith: string[] | undefined = undefined;

    const tagId = urlSearchParams.get('tag');
    const tagIds = urlSearchParams.get('tags');

    if (tagId) {
      taggedWith = [tagId];
    } else if (tagIds) {
      taggedWith = tagIds.split(',');
    }

    if (!tagId && !tagIds) {
      try {
        onlyUntagged = Boolean(
          JSON.parse(urlSearchParams.get('unlabeled') ?? 'false')
        );
      } catch {
        onlyUntagged = false;
      }
    }

    return {
      tagged_with: taggedWith,
      include_tagged_with_descendants: true,
      only_untagged: onlyUntagged,
    };
  }, [search, canCreateTags]);
}
